import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { ReadingAtom } from 'src/app/core/reading-utils/interfaces';
import { TabService } from '../tab.service';
import { DocumentManagerService } from '../document/document-manager.service';
import { AsgardDocBase } from 'src/app/core/documents/asgard-doc-base';

export const GOOGLE_TRANSLATE_URL = `https://translate.google.com/`;

@Injectable({
  providedIn: 'root'
})
export class AsgardTranslateService {
  private get currentDoc(): AsgardDocBase | null | undefined { return this.docMgrService.currentDoc; }

  private get readingItem(): ReadingAtom[] | null {
    return this.currentDoc && this.currentDoc.hasReadingItem ? this.currentDoc.readingItem : null;
  }

  private get currentSelection(): string | null {
    return this.currentDoc ? this.currentDoc.selectedText() : null;
  }

  private get currentLangCode(): string | null {
    return this.tabService.activeTab !== null ? this.tabService.getTabLanguage(this.tabService.activeTab.id) : 'nl';
  }

  private get UILanguageCode(): string {
    return this.settingsService.settings.UILanguageValue;
  }

  private get translateLanguageCodes(): string {
    return `#${this.currentLangCode}/${this.UILanguageCode}/`;
  }

  private get getDefaultLanguageCodes(): string {
    return `#${this.currentLangCode}/en/`;
  }

  constructor(
    private tabService: TabService,
    private settingsService: SettingsService,
    private readonly docMgrService: DocumentManagerService,
  ) { }

  private prepareTextForGoogleTranslatePage(): void {
    let defaultLang  = false;
    if (this.currentLangCode === this.UILanguageCode && this.UILanguageCode !== 'en' && this.currentLangCode !== 'en') {
      defaultLang = true;
    }
    let item = '';
    if (this.currentSelection) {
      item = this.currentSelection;
    } else if (this.readingItem && this.readingItem.length) {
      this.readingItem.forEach(i => item += ` ${i.text}`);
    }
    let result = GOOGLE_TRANSLATE_URL + (defaultLang ? this.getDefaultLanguageCodes : this.translateLanguageCodes);
    if (item && item.length) {
      result += encodeURIComponent(item);
    }
    window.open(result, '_blank');
  }

  public openTranslateTab(): void {
    this.prepareTextForGoogleTranslatePage();
  }
}
